import { render, staticRenderFns } from "./PageEditor.vue?vue&type=template&id=a62d2fd2&scoped=true"
import script from "./PageEditor.vue?vue&type=script&lang=js"
export * from "./PageEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62d2fd2",
  null
  
)

export default component.exports